import { CalendarDays, Lock, MessageSquareText, ShieldCheck, Users } from "lucide-react";
import type { Space } from "../../api/spaces";

function InfoRow({ icon: Icon, label, value }: { icon: React.ElementType; label: string; value: string }) {
    return (
        <div className="bs-space-info-stat flex min-w-0 items-center gap-3 py-2.5">
            <div className="grid h-8 w-8 shrink-0 place-items-center text-neutral-500"><Icon size={15} /></div>
            <div className="min-w-0">
                <div className="text-xs font-semibold text-neutral-500">{label}</div>
                <div className="truncate text-sm font-bold text-neutral-200">{value}</div>
            </div>
        </div>
    );
}

export default function SpaceAbout({ space }: { space: Space }) {
    const access = space.accessMode === "open" ? "Open community" : space.accessMode === "private" ? "Invite only" : space.accessMode === "sealed" ? "Sealed" : "Code required";

    return (
        <div className="bs-space-info-body space-y-4">
            <section className="bs-space-info-about">
                <h2 className="text-lg font-black text-white">About</h2>
                <p className="mt-2 whitespace-pre-wrap text-sm leading-6 text-neutral-300">{space.desc || "This community has not added a description yet."}</p>
            </section>

            <div className="bs-space-info-grid grid sm:grid-cols-2 lg:grid-cols-4 sm:[&>*]:px-2">
                <InfoRow icon={Users} label="Members" value={space.privateStats ? "Private" : space.members || "0"} />
                <InfoRow icon={MessageSquareText} label="Posts" value={String(space.activity?.posts || 0)} />
                <InfoRow icon={CalendarDays} label="Events" value={String(space.activity?.upcomingEvents || 0)} />
                <InfoRow icon={space.accessMode === "open" ? ShieldCheck : Lock} label="Access" value={access} />
            </div>

            {Boolean(space.rules?.length) && (
                <section className="bs-space-guidelines">
                    <h2 className="text-sm font-black text-white">Guidelines</h2>
                    <ol className="mt-3 grid gap-2 md:grid-cols-2">
                        {space.rules?.map((rule, index) => (
                            <li key={rule} className="flex gap-3 rounded-xl border border-white/[0.06] bg-white/[0.018] px-3 py-2.5 text-sm leading-5 text-neutral-400">
                                <span className="font-black text-neutral-600">{index + 1}</span>
                                <span>{rule}</span>
                            </li>
                        ))}
                    </ol>
                </section>
            )}
        </div>
    );
}
